import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import SectionHeading from "../components/SectionHeading";
import ProductCard from "../components/ProductCard";
import { products, categories } from "../config/products";
import CategoryNav from "../components/CategoryNav";

function Products() {
  const [selectedCategory, setSelectedCategory] = useState(null);

  const categoriesWithCounts = categories.map((cat) => ({
    ...cat,
    count: products.filter((p) => p.category === cat.id).length,
  }));

  const filteredProducts = selectedCategory
    ? products.filter((p) => p.category === selectedCategory)
    : products;

  return (
    <>
      <Helmet>
        <title>
          Products — Enterprise Security, AI & Automation Tools | AxiomLabs
          Solutions
        </title>
        <meta
          name="description"
          content="Professional tools designed for security, compliance, and automation. Single binaries, no cloud, no telemetry. One-time purchase, owned forever."
        />
      </Helmet>
      <div className="products-page">
        <div className="container">
          {/* Hero */}
          <div className="products-hero">
            <SectionHeading
              eyebrow="Product Catalog"
              title="Enterprise Solutions"
              subheading="Professional tools designed for security, compliance, and automation. Built for organizations that demand the best."
            />
          </div>

          {/* Category Navigation */}
          <div className="products-navigation">
            <CategoryNav
              categories={categoriesWithCounts}
              selectedCategory={selectedCategory}
              onSelectCategory={setSelectedCategory}
            />
          </div>

          {/* Products Grid */}
          <div className="products-grid">
            {filteredProducts.map((product) => (
              <ProductCard
                key={product.id || product.slug || product.name}
                name={product.name}
                tagline={product.tagline}
                description={product.description}
                status={product.status}
                slug={product.slug}
                path={product.path}
                category={product.category}
                featured={product.featured}
                new={product.new}
                icon={product.icon}
                color={product.color}
                license={product.license}
                openSource={product.openSource}
                githubUrl={product.githubUrl}
                tags={product.tags}
              />
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default Products;
